import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ProgramCategoryService } from 'src/app/core/service/program-category.service';

@Injectable({
    providedIn: 'root'
})
export class ProgramValidators
{
    constructor(private programCategoryService: ProgramCategoryService) { }

    public validateProgramCategoryNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.programCategoryService.existsProgramCategoryName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
